import { IEquipment } from '@/pages/Equipment/equipment.types'
import useEquipmentPassport from '@/pages/Equipment/hooks/useEquipmentPassport'
import Skeleton from '@/shared/Loaders/Skeleton'
import timeUtils from '@/utils/time.utils'
import { useMemo } from 'react'

interface IProps {
  equipment: IEquipment
}

const PassportLastUpdatedLabel = (props: IProps) => {
  const { passport, loading } = useEquipmentPassport(props.equipment.passportInstanceId)
  const passportUpdatedAt = useMemo(() => {
    return passport ? timeUtils.formatDate(passport.updatedAt, 'dd.MM.yyyy, HH:mm') : ''
  }, [passport])

  const renderContent = () => {
    if (loading) return <Skeleton height="22px" width="200px" />

    return (
      <p className="text-nm text-description">
        {passportUpdatedAt ? `Изменено: ${passportUpdatedAt}` : 'Информация не найдена'}
      </p>
    )
  }

  return renderContent()
}

export default PassportLastUpdatedLabel
